export class Specialization {
    specializationId: number;
    specializationIconId: number;
    specializationName: string;
    specializationDescription: string;
    createdDate: Date;
    createdBy: number;
    active: boolean;
    modifiedBy: number;
    modifiedDate: Date;
    url: string;
    iconName: string;
    priority: number;
    locationIds: string;
    locationNames: string;
    encounterTypeId: number;
    encounterName: string;
    consultationTypeId?: number;
    consultationTypeName: string;
} 